import React, { useEffect } from "react";
import { Grid, Typography } from "@material-ui/core";
import {
  BooleanInput,
  FormDataConsumer,
  maxValue,
  minValue,
  NumberInput,
  required,
  TextInput,
} from "react-admin";
import Alert from "@material-ui/lab/Alert";
import CustomDateRangeInput from "../../../components/CustomDateRangeInput";
import { useField, useFormState } from "react-final-form";

interface IStudentSubsidyProps {
  selectedSchool: ISchool;
}

const StudentSubsidyInput = ({ selectedSchool }: IStudentSubsidyProps) => {
  const { values } = useFormState();

  const isApplyStudentSubsidyField = useField("isApplyStudentSubsidy");
  const periodStartDateField = useField("periodStartDate");
  const periodEndDateField = useField("periodEndDate");
  const subsidyPercentageField = useField("subsidyPercentage");

  useEffect(() => {
    isApplyStudentSubsidyField.input.onChange(false);
    periodStartDateField.input.onChange("");
    periodEndDateField.input.onChange("");
    subsidyPercentageField.input.onChange("");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.schoolId]);

  return (
    <FormDataConsumer>
      {({ formData }) =>
        selectedSchool &&
        selectedSchool?.isStudentSubsidyEnable &&
        formData.isNotTakeSchedule === false &&
        (formData.scheduleType === "regular" ||
          formData.scheduleType === "both") && (
          <>
            <Grid item xs={4} style={{ marginTop: "15px" }}>
              <BooleanInput
                source="isApplyStudentSubsidy"
                label="Apply Student Subsidy"
                defaultValue={false}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            {formData.isApplyStudentSubsidy && (
              <>
                {formData.scheduleType === "both" && (
                  <Grid item xs={4} style={{ marginTop: "-35px" }}>
                    <Alert severity="info">
                      Subsidy only apply to Regular Schedule Price
                    </Alert>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Typography variant="h6">Subsidy Details</Typography>
                </Grid>

                <Grid item xs={12}>
                  <CustomDateRangeInput
                    fromSource="periodStartDate"
                    toSource="periodEndDate"
                    fromLabel="Period Start Date"
                    toLabel="Period End Date"
                    gridItemWidth={2}
                  />
                </Grid>

                <Grid item xs={4}>
                  <NumberInput
                    source="subsidyPercentage"
                    label="Subsidy Percentage (%)"
                    validate={[required(), minValue(0.1), maxValue(100)]}
                  />
                </Grid>
                <Grid item xs={8}></Grid>

                <Grid item xs={4}>
                  <TextInput
                    multiline={true}
                    label="Remark"
                    source="remark"
                  />
                </Grid>
              </>
            )}
          </>
        )
      }
    </FormDataConsumer>
  );
};

export default StudentSubsidyInput;
